import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddPalletDataComponent } from 'src/app/core/dialogs/add-pallet-data/add-pallet-data.component';
import { DeletePalletDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-pallet-dialog.component';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { PalleteTypeService } from 'src/app/service/asn/pallet-type.service';
import { ExcelService } from 'src/app/service/excel.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-asn-pallet-types',
    templateUrl: './asn-pallet-types.component.html',
    styleUrls: ['./asn-pallet-types.component.scss'],
    standalone: false
})
export class ASNPalletTypesComponent implements OnInit {
  gridApi: any;
  successMessage
  errorMessage
  columnDefs = [];
  displayRowData = [];
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  defaultColDef;
  gridOptions
  icons;
  context: any;
  isAccessible = false;
  paginationPageSize: number = 20;
	setPagination = 'true';
  @ViewChild('agGrid', { static: true }) agGrid
	dynamicHeight: number;
	totalRecords = 0; // Replace with your actual total records count
	sRecord = 1;
	eRecord = 1;
	cPage = 1;
	tPage = 0;
	rpPage: any = 20;
	endRecord = 0;
	pgDropDown = [
		{value: 5 , selected : false},
		{value: 10 , selected : false},
		{value: 20 , selected : true},
		{value: 50 , selected : false},
    {value: 'ALL' , selected : false},
	]
  constructor(private readonly router: Router, public dialog: MatDialog, private readonly excelService: ExcelService, private readonly exportStateService: ExportStateService,
    private readonly constants: Constants, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly palletTypeService: PalleteTypeService) {
    this.context = {
      componentParent: this
    };
    this.defaultColDef = {
      suppressMovable: true, wrapText: true
    }
  }

  ngOnInit(): void {
    this.dynamicHeight = 0.665 * (window.innerHeight) - 55;
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    // this.checkRoles();
    this.columnDefs = [
      {
        headerName: "TYPE", field: "type", suppressFloatingFilterButton: true, suppressHeaderMenuButton: true, suppressMenu: true, floatingFilter: true,
        filter: 'agTextColumnFilter', maxWidth: 80, sortable: true, unSortIcon: true,
      },
      {
        headerName: "DESCRIPTION", field: "description", autoHeight: true, sortable: true, unSortIcon: true,//width: 200,wrapText: true
      },
      {
        headerName: "LENGTH", field: "length", maxWidth: 90
      },
      {
        headerName: "WIDTH", field: "width", maxWidth: 90
      },
      {
        headerName: "HEIGHT", field: "height", maxWidth: 90
      },
      {
        headerName: "WEIGHT", field: "weight", maxWidth: 90
      },
      {
        headerName: "BASE PRICE", field: "basePrice", maxWidth: 120
      },
      {
        headerName: "CURRENCY", field: "currency", maxWidth: 100
      },
      {
        headerName: "COUNTRY", field: "country", maxWidth: 100
      },
      {
        headerName: "DIMENSION", field: "dimension", maxWidth: 110
      },
      {
        headerName: "WEIGHT UOM", field: "weightUOM", maxWidth: 110
      },
      {
        headerName: "ACTIONS", field: "palletType_editdelete", maxWidth: 120,
        cellRenderer: BtnCellRendererEditDelete
      }];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    this.RefreshData();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.exportStateService.getRoles();
    const roles = this.exportStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_NAMCPlanner60EXP)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // } // Commented for APM
  }

  sizeToFit() { this.gridApi.sizeColumnsToFit(); }

	goToFirstPage() { this.gridApi.paginationGoToFirstPage(); this.updatePaginationDetails(); }

	goToLastPage() { this.gridApi.paginationGoToLastPage(); this.updatePaginationDetails(); }

	goToNextPage() { this.gridApi.paginationGoToNextPage(); this.updatePaginationDetails(); }

	goToPreviousPage() { this.gridApi.paginationGoToPreviousPage(); this.updatePaginationDetails(); }

  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
      {this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length)); this.updatePaginationDetails();}
    else
     { this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value)); this.updatePaginationDetails();}
  }

  getCurrentPage(): boolean {
		if (this.cPage == 1) {  // NOSONAR
			this.currentPageBoolean = true;
		}
		else { this.currentPageBoolean = false; }
		return this.currentPageBoolean;
	}

	isLastPage(): boolean {
		this.currentPageForTotalPage = Number(this.cPage);
		if (this.tPage == this.currentPageForTotalPage) {  // NOSONAR
			this.isLastPageFound = true;
		}
		else {
			this.isLastPageFound = false;
		}
		return this.isLastPageFound;
	}

	rppChanged(event:any) {
		this.cPage = 1;
    event.target.value === 'ALL' ? this.gridApi?.setGridOption('paginationPageSize', this.totalRecords) : this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
		this.updatePaginationDetails();
	}

	updatePaginationDetails() {
		if (this.gridApi) {
			this.cPage = this.gridApi.paginationGetCurrentPage() + 1;
			this.tPage = this.gridApi.paginationGetTotalPages();

			this.sRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + 1
			this.eRecord = (this.gridApi.paginationGetPageSize() * this.gridApi.paginationGetCurrentPage()) + this.gridApi.paginationGetPageSize()
			this.totalRecords = this.gridApi.paginationGetRowCount();
			this.eRecord = this.totalRecords < this.eRecord ? this.totalRecords : this.eRecord;
		}
	}

  defaultRowData() {
    this.displayRowData = [];
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
  }

  RefreshData() {
    this.displayRowData = []
    this.gridApi?.setGridOption('rowData', this.displayRowData);
    this.rowCount = this.displayRowData.length;
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.palletTypeService.loadDataPalletType().subscribe(
      response => {
        this.displayRowData = response
        this.gridApi?.setGridOption('rowData', this.displayRowData);
        this.rowCount = this.displayRowData.length;
        if (this.displayRowData.length) {
					this.totalRecords = this.displayRowData.length;
					this.paginationPageSize = this.rpPage !== 'ALL' ? this.paginationPageSize : this.totalRecords;
					this.tPage = this.rpPage !== 'ALL' ? Math.ceil(this.totalRecords / this.rpPage) : 1;
					this.sRecord = 1
					this.eRecord = this.rpPage > this.totalRecords ? this.totalRecords : this.rpPage
					if (this.cPage > this.tPage) {
						this.cPage = 1;
					}
				}
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      },
      _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        this.defaultRowData();
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
      }
    );
  }

  deleteTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      DeletePalletDialogComponent, {
      disableClose: true,
      width: 'max-content',
      data: {
        header: 'Are you sure you want to delete this Pallet Type?',
        description: "Type : " + data.type,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.event == "ConfirmEvent") { // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.palletTypeService.deletePalletTypeData(data.type).subscribe(
          response => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            if (response == "Success") { // NOSONAR
              this.successMessage = this.constants.APIDataDeleted;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTimeShort);
              this.RefreshData();
            }
          }, _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          })
      }
    }
    )

  }

  editTemplateRow(data, _pagename) {
    const dialogRef = this.dialog.open(
      AddPalletDataComponent, {
      disableClose: true,
      width: '820px',
      data: {
        header: 'EDIT PALLET TYPES',
        eventType: 'EDIT',
        type: data.type,
        description: data.description,
        length: data.length,
        width: data.width,
        height: data.height,
        weight: data.weight,
        basePrice: data.basePrice,
        currency: data.currency,
        country: data.country,
        dimension: data.dimension,
        weightUOM: data.weightUOM
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataUpdated;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.RefreshData();
      }
    });
  }

  addPalletType() {
    const dialogRef = this.dialog.open(
      AddPalletDataComponent, {
      disableClose: true,
      width: '820px',
      data: {
        header: 'ADD PALLET TYPES',
        eventType: 'ADD'
      }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') { // NOSONAR

        this.successMessage = this.constants.APIDataSaved;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTimeShort);
        this.RefreshData();

      }
    });
  }

  onBtExport() {
    if (this.displayRowData?.length > 0) {
      const headers = ['Type', 'Description', 'Length', 'Width', 'Height', 'Weight', 'Base Price', 'Currreny',
        'Country', 'Dimension', 'Weight UOM'];
      const exportData = [];
      let linkData = [];
      if (Object.keys(this.gridApi?.getFilterModel()).length > 0) {
        const rowData = []
        this.gridApi.forEachNodeAfterFilter(node => { rowData.push(node.data) });
        linkData = rowData;
      } else
        {linkData = this.displayRowData}
      linkData.forEach(e => {
        const obj = {
          Type: e.type,
          Description: e.description,
          Length: e.length,
          Width: e.width,
          Height: e.height,
          Weight: e.weight,
          basePrice: e.basePrice,
          Currreny: e.currency,
          Country: e.country,
          Dimension: e.dimension,
          WeightUOM: e.weightUOM
        };
        exportData.push(obj);
      });
      this.excelService.exportAsExcelFile(exportData, 'PALLET-TYPES', headers);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }

  openRouteLevel(route) {
    this.router.navigate([`/${route}`]);
  }

}
